import { IWeatherInfo, IWeatherItem, ResortWeatherLocation } from 'api/resort/types';
import classNames from 'classnames';
import { ResortWeatherRow, ResortWeatherRowHeader } from 'components/resort/ResortWeatherRow';
import styles from 'components/resort/ResortWeather/styles.module.scss';
import { MeteoLogo } from 'components/resort/ResortWeather/MeteoLogo';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { DateTime } from 'luxon';
import { AutoScroll } from 'components/blocks/AutoScroll';
import { formatShortDateStr } from 'util/formatDate';

export const Hourly = (
  { weatherHourly, weatherLocation }: { weatherHourly: IWeatherInfo, weatherLocation: ResortWeatherLocation },
) => {
  const dates: { [key: string]: Array<IWeatherItem> } = {};
  const checkLastItem = (i: number) => i === Object.keys(dates).length - 1;
  const { t } = useOTSTranslation('common');

  weatherHourly.weatherItems.forEach((item) => {
    const date = DateTime.fromISO(item.datetime, { setZone: true }).toLocaleString();

    if (!Object.prototype.hasOwnProperty.call(dates, date)) {
      dates[date] = [item];
    } else {
      dates[date].push(item);
    }
  });

  return (
    <AutoScroll>
      <div className={classNames(styles.autoScroll, styles.hourlyWrap, styles.visible)}>
        <>
          {
            Object.keys(dates).map((item, i) => (
              <section key={item} className={classNames(styles.box, styles.inner)}>
                <table>
                  <caption style={{ display: 'none' }}>{t('common.hourlyWeatherForecast', { date: formatShortDateStr(dates[item][0].datetime) })}</caption>
                  <ResortWeatherRowHeader
                    updatedAt={dates[item][0].datetime}
                    base={weatherHourly.base}
                    summit={weatherHourly.summit}
                  />
                  <tbody>
                    {dates[item].map((row: IWeatherItem, index: number) => (
                      <ResortWeatherRow
                        key={row.datetime}
                        weatherItem={row}
                        weatherLocation={weatherLocation}
                        isHourly
                        className={index % 2 ? '' : styles.other}
                      />
                    ))}
                  </tbody>
                </table>
                {
                  checkLastItem(i) ? (
                    <MeteoLogo logo={weatherHourly.weatherLogo} className={styles.logo} />
                  ) : null
                }
              </section>
            ))
          }
        </>
      </div>
    </AutoScroll>
  );
};
